export default __webpack_public_path__ + "static/media/dianoiva_6.2be8570a.jpg";